/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Fit_5Inputs */

const en_pc_alt_fit_5 = /** @type {(inputs: Pc_Alt_Fit_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You want to script PDF jobs, or let an AI agent work on PDFs, through pdfcraft-cli and its opt-in MCP server.`)
};

const zh_pc_alt_fit_5 = /** @type {(inputs: Pc_Alt_Fit_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你想用脚本处理 PDF，或通过 pdfcraft-cli 及其需手动启用的 MCP 服务器让 AI 智能体处理 PDF。`)
};

/**
* | output |
* | --- |
* | "You want to script PDF jobs, or let an AI agent work on PDFs, through pdfcraft-cli and its opt-in MCP server." |
*
* @param {Pc_Alt_Fit_5Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_fit_5 = /** @type {((inputs?: Pc_Alt_Fit_5Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Fit_5Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_fit_5(inputs)
	return zh_pc_alt_fit_5(inputs)
});
export { pc_alt_fit_5 as "pc.alt.fit.5" }